import React, { Component } from 'react';
import config from 'config/config';

class ConversationSetupFAQ extends Component {
  render() {
    return (
      <div className="faqs">
        <div className="faq">Common Questions</div>
        <div className="faq">
          Can I implement both circulation and the community spotlight on my page?
        </div>
        <div className="faq-description">
          Yes. While your visitors will enjoy navigating between different articles using the
          recirculation, they will learn about your community and potentially become registered
          users with the Community Spotlight.
        </div>

        <div className="faq">
          What are the display and video ad unit dimensions within the Community Spotlight?
        </div>
        <div className="faq-description">
          Display unit dimensions are 400X300, Ad dimensions are 300X250.
        </div>

        <div className="faq">Does the Community Spotlight feature offer native advertising?</div>
        <div className="faq-description">
          Yes. The Community Spotlight is able to present native ads instead of the recommended
          default configuration that includes both display and video ads. In case you prefer using
          only native, please contact your AM.
        </div>
        <div className="faq">
          Is the Community Spotlight rev share different from other OpenWeb monetization
          opportunities?
        </div>
        <div className="faq-description">No. The same conditions apply.</div>

        <div className="faq">Still have questions?</div>
        <div className="faq-description">
          <span>
            Visit our
            <a className="faq-link" href={config.api.urls.support} target="_blank">
              {' '}
              support{' '}
            </a>
            site or go ahead and
            <a className="faq-link" href={config.api.urls.contact} target="_blank">
              {' '}
              contact{' '}
            </a>
            our support team.
          </span>
        </div>
      </div>
    );
  }
}

export default ConversationSetupFAQ;
